import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import * as AUTH_AT from "./actionTypes";
import { BankIdRefererType } from "../../../../constants";
import {
    API_URL_BANK_ID_AUTHORIZE2,
    API_URL_BANK_ID_AVAILABLE,
    API_URL_BANK_ID_DSF_MISMATCH,
} from "../../../../constants/api/bankid";
import { CreditCheckDecision } from "../../../../constants/creditCheck";
import { RootState } from "../../../../models";
import * as Ajax from "../../app/Ajax";

import { BANK_ID_TYPES, BankIdTypes } from "../consts";

export const logout = (): ThunkAction<void, RootState, unknown, AnyAction> => async (dispatch) => {
    return Ajax.post({ url: "/shop/api/security/logout" })
        .then((data) => {
            dispatch({
                type: AUTH_AT.AUTH_LOGOUT_SUCCEEDED,
                data,
            });
        })
        .catch(() => {
            dispatch({
                type: AUTH_AT.AUTH_LOGOUT_FAILED,
            });
        });
};

export const isAuthenticated = (): ThunkAction<void, RootState, unknown, AnyAction> => async (dispatch) => {
    return Ajax.get({ url: "/shop/api/security/isauthenticated" }, dispatch)
        .then((data) => {
            dispatch({
                type: AUTH_AT.AUTH_IS_AUTHENTICATED_SUCCEEDED,
                data,
            });
        })
        .catch(() => {
            dispatch({
                type: AUTH_AT.AUTH_IS_AUTHENTICATED_FAILED,
            });
        });
};

export type AuthMethodType = "BANK_ID" | "CANDOUR";

// Telia Broker
export const bankIdAuthorize2 = (
    type: BankIdTypes = BANK_ID_TYPES.ALL,
    referer?: BankIdRefererType,
    authMethod: AuthMethodType = "BANK_ID",
) => ({
    type: AUTH_AT.AUTH_BANK_ID_AUTHORIZE,
    payload: Ajax.get({
        url: `${API_URL_BANK_ID_AUTHORIZE2}?type=${type}&referer=${referer}&authMethod=${authMethod}`,
    }),
});

export const bankIdAvailable = (referer: BankIdRefererType = "shop") => ({
    type: AUTH_AT.AUTH_BANK_ID_AVAILABLE,
    payload: Ajax.get({
        url: `${API_URL_BANK_ID_AVAILABLE}?referer=${referer}`,
    }),
});

export const bankIdHandleDsfMismatch =
    (overrideFirstName?: string, overrideLastName?: string): ThunkAction<void, RootState, unknown, AnyAction> =>
    async (dispatch) =>
        dispatch({
            type: AUTH_AT.AUTH_BANK_ID_GRANT,
            payload: Ajax.post<{
                decision: CreditCheckDecision;
                message: string;
            }>(
                {
                    url: API_URL_BANK_ID_DSF_MISMATCH,
                    data: {
                        overrideFirstName,
                        overrideLastName,
                    },
                },
                dispatch,
            ).then(({ message, decision, ...rest }) => ({
                success: decision === "OK",
                message: decision === "OK" ? null : message,
                ...rest,
            })),
        });

export const bankIdReset = () => ({
    type: AUTH_AT.AUTH_BANK_ID_RESET,
});
